export default "__VITE_ASSET__gTp7sFXC__"